import usePartyCurrency from '../../../../../parties/src/hooks/usePartyCurrency';
import useCreationFlowReport from './useCreationFlowReport';

const useAdvisoryReportCurrency = () => {
  const { data } = useCreationFlowReport();
  return usePartyCurrency(data?.party?.id);
};

export default useAdvisoryReportCurrency;
